import React from 'react';
import Typography from './Typography';
import { FaChevronDown } from 'react-icons/fa';

const CustomSelect = ({
  label,
  name,
  id,
  value,
  onChange,
  options,
  borderLeft = false,
  borderRight = false,
  ...props
}) => {
  return (
    <div className="custom-select-container">
      <div className="custom-select-label">
        <Typography size="14px" color="#FFF" text={label} />
      </div>
      <div className="custom-select-wrapper">
        {borderLeft && <div className="w-[3px] h-[24px] bg-[#1C1C1C]"></div>}
        <div className="custom-select-content px-2">
          <select
            name={name}
            id={id}
            value={value}
            required
            onChange={onChange}
            className="custom-select-field"
            {...props}
          >
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <FaChevronDown className="text-white" />
        </div>
        {borderRight && <div className="w-[3px] h-[24px] bg-[#1C1C1C]"></div>}
      </div>
    </div>
  );
};

export default CustomSelect;